import { render, staticRenderFns } from "./EarlyGoersChip.vue?vue&type=template&id=76f3e6ed"
import script from "./EarlyGoersChip.vue?vue&type=script&lang=js"
export * from "./EarlyGoersChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports